import React from "react";
import styled from "styled-components";
import {DataRefreshRatePill, Headings, Title} from "../../Sections";
import {Option} from "../option/Option";

const Container = styled(Headings)`
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 16px;
    font-weight: normal;
    height: 46px
`;

const DataUpdatedContainer = styled.div`
    display: flex;
    flex-grow: 1;
`;

const Scope = styled.div`
    display: flex;
    align-self: stretch;
    justify-self: flex-end;
`;

export const TitleBar = ({rankingsView, portfolioAuthorActions}) => {
    return <Container className="t-title-bar">
        <Title>Rankings by KPI</Title>
        <DataUpdatedContainer>
            <DataRefreshRatePill className="t-data-updated-pill"/>
        </DataUpdatedContainer>
        <Scope className="t-options">
            <Option className="t-all-contributors"
                    width="50px"
                    selected={rankingsView === "all-contributors"}
                    text="All"
                    onClick={() => portfolioAuthorActions.changeRankingsView("all-contributors")}/>
            <Option className="t-my-team"
                    width="70px"
                    text="My Team"
                    selected={rankingsView === "my-team"}
                    onClick={() => portfolioAuthorActions.changeRankingsView("my-team")}/>
        </Scope>
    </Container>;
};